import React, { useEffect, useState } from "react";
import { Error } from "../../../Messages/Messages";
import axios from "axios";
import { useParams } from "react-router-dom";
import InvoicesList from "../../../Billing/Invoices/InvoicesList";
import Loading from "../../../Loading/Loading";
import SearchBarComp from "../../../SearchBar/SearchBar";
import MainButtonComp from "../../../Buttons/MainButtonComp";
import AddInvoices from "../../../Billing/Invoices/AddInvoices";
import { checkSpecificPermission } from "../../../../utils/checkPermissions";
import { isAuthenticated } from "../../../Auth/auth";
import { generalErrorAlert } from "../../../GeneralErrorAlert";
import PageToolbar from "../../../../design-system/PageToolbar";

const WholeProjectInvoice = ({ projectDetails }) => {
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize] = useState(15);
  const [searchText, setSearchText] = useState("");
  const [totalCount, setTotalCount] = useState("");
  const [data, setData] = useState([]);
  const [milestonesArray, setMilestonesArray] = useState([]);
  const [invoiceModal, setInvoiceModal] = useState(false);

  const getData = async () => {
    setLoading(true);
    await axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/invoices/invoices/filters`,
        {
          project: params.id,
          inControl: true,
          noMilestone: true,
          searchText,
          pageSize,
          pageNo: pageNo - 1
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      )
      .then(res => {
        setLoading(false);
        if (res.status === 200 || res.status === 304) {
          setData(res.data.data);
          setTotalCount(res.data.count);
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        setLoading(false);
        generalErrorAlert(err);
      });
  };

  const getMilestones = async () => {
    await axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/milestones/filters`,
        { projectId: params?.id, pageSize: 100000000, pageNo: 0 },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      )
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          setMilestonesArray(res.data.data);
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        if (err.response?.data?.errorMessage) {
          Error(err.response?.data?.errorMessage);
        } else {
          Error(err.message);
        }
      });
  };

  useEffect(() => {
    getData();

    return () => {};
  }, [params, searchText, pageNo]);

  useEffect(() => {
    getMilestones();

    return () => {};
  }, [params]);

  const handleSearch = value => {
    setSearchText(value);
    setPageNo(1);
  };

  const closeInvoiceModal = () => {
    setInvoiceModal(false);
  };

  return (
    <>
      <PageToolbar
        filters={<SearchBarComp handleSearch={handleSearch} />}
        actions={
          <div>
            {checkSpecificPermission(
              isAuthenticated()?.roleId?.permissions,
              "Invoices",
              "Create"
            ) && (
              <AddInvoices
                wholeProject={true}
                prefillData={projectDetails}
                closeModal={closeInvoiceModal}
                openModal={invoiceModal}
                milestones={milestonesArray}
                updateParent={getData}
                project={params.id}
              />
            )}
            {!invoiceModal && (
              <MainButtonComp
                onClick={() => setInvoiceModal(!invoiceModal)}
                addBtn
                text="Generate whole project invoice"
              />
            )}
          </div>
        }
      />

      {loading ? (
        <Loading />
      ) : (
        <InvoicesList
          totalCount={totalCount}
          pageSize={pageSize}
          setPageNo={setPageNo}
          pageNo={pageNo}
          data={data}
          updateParent={getData}
        />
      )}
    </>
  );
};

export default WholeProjectInvoice;
